import { get } from 'lodash';
import { createSelector } from 'reselect';
import { getFeedTitle } from '@wix/communities-blog-client-common';
import { getViewerAllPostsLabelTranslation } from '../../common/selectors/viewer-all-post-label-translation-selectors';
import { getShowAllPostsCategory } from '../selectors/category-menu-selectors';

const getCategoryMenuWidgetData = (state) => state.categoryMenuWidget;

export const getCategoryMenu = createSelector(
  getCategoryMenuWidgetData,
  getShowAllPostsCategory,
  getFeedTitle,
  getViewerAllPostsLabelTranslation,
  (categoryMenu, showAllPosts, title, translatedTitle) => {
    if (showAllPosts && get(categoryMenu, 'categoryMenu[0].display.text')) {
      categoryMenu.categoryMenu[0].display.text = translatedTitle || title;
    } else {
      categoryMenu.categoryMenu = categoryMenu.categoryMenu.slice(1);
    }
    return categoryMenu;
  },
);
